import { render, staticRenderFns } from "./Skin.vue?vue&type=template&id=6ab22c0e"
import script from "./Skin.vue?vue&type=script&lang=js"
export * from "./Skin.vue?vue&type=script&lang=js"
import style0 from "./Skin.vue?vue&type=style&index=0&id=6ab22c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports